const agents = [
	{
		path: '/ai/agent-runs',
		name: 'ai-agent-runs-list',
		component: () => import('@/views/ai/agents/runs/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAI,agents',
		},
	},
	{
		path: '/ai/agent-runs/:uuid',
		name: 'ai-agent-runs-detail',
		component: () => import('@/views/ai/agents/runs/detail.vue'),
		meta: {
			layout: 'content',
			module: 'MGAI,agents',
		},
	},
	{
		path: '/ai/agents',
		name: 'ai-agents-list',
		component: () => import('@/views/ai/agents/agents/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAI,agents',
		},
	},
]

export default agents
